function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.57607 4.68423C4.57074 4.6786 4.56363 4.67635 4.5583 4.67073L1.13286 0.743622C0.94014 0.524261 0.627525 0.524261 0.434805 0.743622C0.433028 0.745872 0.43214 0.748121 0.431252 0.750371C0.384587 0.799176 0.346898 0.8603 0.32082 0.929472C0.294743 0.998644 0.280905 1.07419 0.280273 1.15084L0.280273 9.00618C0.281269 9.08423 0.295784 9.16106 0.322793 9.23123C0.349802 9.3014 0.388646 9.36321 0.436581 9.41228L0.434805 9.41453C0.531774 9.52068 0.655663 9.5791 0.783832 9.5791C0.912001 9.5791 1.03589 9.52068 1.13286 9.41453L4.57607 5.47842C4.62141 5.42942 4.65783 5.36854 4.6828 5.29998C4.70777 5.23143 4.7207 5.15682 4.7207 5.08132C4.7207 5.00582 4.70777 4.93122 4.6828 4.86266C4.65783 4.79411 4.62141 4.73323 4.57607 4.68423Z",
  fill: "#646972"
});

var SvgRightArrow = function SvgRightArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RightArrow.f30d3871.svg";
export { ForwardRef as ReactComponent };